import { Link } from 'react-router';
import { Icon } from '../../components/Icon';
import { Alert } from '../../components/States';
import { SETUP_ITEM_LABELS, STEP_FOR_ITEM, useSetupStatus } from '../../lib/setup-api';
import { useIsAdmin } from '../../lib/session';

/** "Configuração incompleta" checklist (design QQ-Pendente). */
export function SetupChecklist() {
  const status = useSetupStatus();
  const isAdmin = useIsAdmin();
  if (!status.data) return <div className="skel" style={{ height: 240 }} />;
  const items = status.data.items;
  const missing = items.filter((i) => !i.done);
  const firstMissing = missing[0];
  return (
    <section className="card col" style={{ gap: 14 }}>
      {missing.length === 0 ? (
        <Alert tone="ok">
          <b>Tudo pronto.</b> Já dá para orçar com preço por canal.
        </Alert>
      ) : (
        <Alert tone="warn">
          <b>Configuração incompleta.</b>{' '}
          {missing.length === 1 ? 'Falta 1 item' : `Faltam ${missing.length} itens`} para calcular
          preços.
        </Alert>
      )}
      <div className="layers thin" aria-hidden="true">
        <div
          className="fill"
          style={{ width: `${((items.length - missing.length) / items.length) * 100}%` }}
        />
      </div>
      <p className="sm muted">
        {items.length - missing.length} de {items.length} prontos
      </p>
      <div className="col" style={{ gap: 0 }}>
        {items.map((i) => (
          <div key={i.key} className="listrow">
            <span className={i.done ? 'box on' : 'box'} style={{ borderRadius: '50%' }}>
              {i.done ? <Icon name="check" size={14} strokeWidth={3} /> : null}
            </span>
            <div className="grow" style={{ minWidth: 0 }}>
              <p style={{ fontWeight: 500 }}>{SETUP_ITEM_LABELS[i.key].title}</p>
              <p className="xs muted">{i.done ? i.detail : SETUP_ITEM_LABELS[i.key].todo}</p>
            </div>
          </div>
        ))}
      </div>
      {firstMissing ? (
        isAdmin ? (
          <Link
            className="btn p block"
            to={`/configuracao-inicial?passo=${STEP_FOR_ITEM[firstMissing.key]}`}
          >
            Continuar configuração
          </Link>
        ) : (
          <p className="sm muted">Peça ao Admin para terminar a configuração.</p>
        )
      ) : null}
    </section>
  );
}
